/**
 * Handle race registration overview
 *
 *  @param {string} raceCardsSelector - selector for race cards
 */

import { isItOpen, closeIt, openIt } from './utils/showHide';

export const raceRegistrationOverview = (
    raceCardsSelector = '.fwtm-race-category-card[data-controls]'
) => {
    const raceCards = document.querySelectorAll(raceCardsSelector);

    Array.prototype.forEach.call(raceCards, (raceCard) => {
        raceCard.addEventListener('click', function (event) {
            event.preventDefault();

            let expanded = isItOpen(this);
            if (!expanded) {
                // the clicked one is closed, open it + close the others
                const shouldClose = [...raceCards].filter(
                    (card) => card !== this
            );
                shouldClose.forEach((el) => closeIt(el));
                openIt(this);
            } else {
                // the clicked one is open, close it
                closeIt(this);
            }
        });
    });
}
